import { motion } from "framer-motion";

const devices = [
  "Web TV",
  "Samsung Smart TV",
  "Android",
  "Roku",
  "Fire TV",
  "LG Smart TV",
  "Apple TV",
];

const Devices = () => (
  <section id="devices" data-testid="devices-section" className="relative py-10 md:py-12">
    <div className="max-w-6xl mx-auto px-6 md:px-10 text-center">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#22D3EE] font-semibold mb-4">
        Watch everywhere
      </div>
      <h2 className="font-display text-4xl md:text-6xl font-extrabold leading-tight">
        Available on your <span className="gradient-text">favourite screens.</span>
      </h2>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mt-10 flex flex-wrap items-center justify-center gap-3"
      >
        {devices.map((d) => (
          <span
            key={d}
            data-testid={`device-${d.toLowerCase().replace(/\s+/g, "-")}`}
            className="rounded-full border border-[#22D3EE]/25 bg-white/5 backdrop-blur px-5 py-3 text-sm md:text-base font-medium text-white/90 hover:bg-white/10 hover:border-[#22D3EE]/60 hover:shadow-[0_0_25px_-4px_rgba(34,211,238,0.55)] transition-all"
            style={{ boxShadow: "0 0 20px -8px rgba(34,211,238,0.35)" }}
          >
            {d}
          </span>
        ))}
      </motion.div>
    </div>
  </section>
);

export default Devices;
